/**
 * Timing constants (ms)
 */
export const DELAY = {
  ACCESS_OPACITY: 200,
  DETAIL_CONTENT: 200,
  DESCRIPTION_CONTENT: 400,
  DESCRIPTION_HEADER: 200,
  DISK: 200,
  MAIN_CONTENT_VERTICAL: 200,
  PAUSE_AD: 1000,
  PILOT_FOOTER_CONTENT: 200,
  PLAYER_CONTAINER: 300,
  SEARCH_RAILS_SCROLL_UP: 300,
  SLIDER_LIST_CONTAINER: 300,
  SLIDER_PRESSABLE_CONTAINER: 500,
  TOAST_AUTO_CLOSE: 3000,
} as const;

export const DURATION = {
  ARROW_FADE: 100,
  CHANNEL_LIST_CONTENT: 150,
  CHANNEL_LIST_INFO: 150,
  DESCRIPTION_CONTENT: 200,
  DESCRIPTION_HEADER: 200,
  DETAIL_SCROLL: 150,
  DIAL_INPUT: 200,
  DISK_CAPACITY_INNER_BAR: 300,
  FLOATING_MENU_LIST: 200,
  GRID_WRAPPER: 150,
  LANGUAGE_ITEM: 150,
  MAIN_CONTENT_VERTICAL_HEIGHT: 500,
  MAIN_CONTENT_VERTICAL_TRANSFORM: 200,
  MENU_BACKGROUND: 500,
  MENU_CONTAINER: 200,
  MENU_LOGIN: 200,
  MENU_ITEM_OPACITY: 0,
  MENU_ITEM_ICON: 0,
  MENU_ITEM_TEXT: 0,
  MENU_SEARCH_FILL: 200,
  MENU_SEARCH_OPACITY: 200,
  MENU_SEARCH_TRANSLATION: 200,
  NEXT_EPISODE_FILL: 1000,
  OPACITY_TRANSITION: 500,
  PAUSE_AD: 300,
  PLAYER_CONTAINER: 300,
  PROGRESS_UPDATE: 200,
  RAILS_CONTAINER: 300,
  RAILS_WRAPPER: 150,
  SEARCH_KEYBOARD_SCROLL: 300,
  SEARCH_RAILS_SCROLL: 150,
  SLIDER_LIST_CONTAINER: 300,
  SPINNER_PATH: 200,
  SPLASH: 200,
  SWITCHER_BALL_BACKGROUND: 1000,
  SWITCHER_BALL_TRANSFORM: 600,
  TOP_BAR_CONTAINER: 200,
} as const;

/**
 * Transform offsets (px, unscaled) for collapse-driven animations
 */
export const OFFSET = {
  CHANNELS_CHOICE_HORIZONTAL: {
    COLLAPSED: 50,
    EXPANDED: -20,
  },
  GRID_VERTICAL: {
    COLLAPSED: 570,
    EXPANDED: 120,
  },
  MAIN_HORIZONTAL: {
    COLLAPSED: 200,
    EXPANDED: 0,
  },
  MAIN_VERTICAL: {
    COLLAPSED: 120,
    EXPANDED: 508,
  },
  SEARCH_HORIZONTAL: {
    COLLAPSED: 180,
    EXPANDED: 0,
  },
} as const;

/**
 * CSS transitions
 */
export const TRANSITION = {
  ARROW_FADE: `opacity ${DURATION.ARROW_FADE}ms ease-in-out`,
  CHANNEL_LIST_CONTENT: `left ${DURATION.CHANNEL_LIST_CONTENT}ms ease-in-out`,
  CHANNEL_LIST_INFO: `width ${DURATION.CHANNEL_LIST_INFO}ms ease-in-out`,
  DETAIL_SCROLL: `transform ${DURATION.DETAIL_SCROLL}ms`,
  DISK_CAPACITY_INNER_BAR: `width ${DURATION.DISK_CAPACITY_INNER_BAR}ms`,
  FLOATING_MENU_LIST: `transform ${DURATION.FLOATING_MENU_LIST}ms`,
  LANGUAGE_ITEM: `transform ${DURATION.LANGUAGE_ITEM}ms`,
  LIST_ANIMATION: (duration: number) => `transform ${duration}s linear`,
  MAIN_CONTENT_VERTICAL: `transform ${DURATION.MAIN_CONTENT_VERTICAL_TRANSFORM}ms linear ${DELAY.MAIN_CONTENT_VERTICAL}ms, height ${DURATION.MAIN_CONTENT_VERTICAL_HEIGHT}ms ease-in-out ${DELAY.MAIN_CONTENT_VERTICAL}ms`,
  MENU_CONTAINER: (collapse: boolean) =>
    `background ${collapse ? `${DURATION.MENU_BACKGROUND}ms` : '0ms'} ease-out, 
      border ${DURATION.MENU_CONTAINER}ms ease-out`,
  MENU_ITEM_TEXT: `max-width ${DURATION.MENU_ITEM_TEXT}ms ease-out,
      padding-left ${DURATION.MENU_ITEM_TEXT}ms ease-out,
      padding-right ${DURATION.MENU_ITEM_TEXT}ms ease-out`,
  MENU_SEARCH_FILL: `fill ${DURATION.MENU_SEARCH_FILL}ms ease-out`,
  MENU_SEARCH_TRANSLATION: `left ${DURATION.MENU_SEARCH_TRANSLATION}ms ease-out`,
  NEXT_EPISODE_FILL: `width ${DURATION.NEXT_EPISODE_FILL}ms linear`,
  OPACITY_TRANSITION: `opacity ${DURATION.OPACITY_TRANSITION}ms`,
  PAUSE_AD: (duration?: number, delay?: number) =>
    `opacity ${duration}ms ease-in-out ${delay}ms`,
  PROGRESS_UPDATE: `width ${DURATION.PROGRESS_UPDATE}ms linear`,
  RAILS_WRAPPER: `transform ${DURATION.RAILS_WRAPPER}ms linear ${DURATION.MENU_CONTAINER}ms`,
  SEARCH_KEYBOARD_SCROLL: `transform ${DURATION.SEARCH_KEYBOARD_SCROLL}ms linear`,
  SEARCH_RAILS_SCROLL_DOWN: `transform ${DURATION.SEARCH_RAILS_SCROLL}ms`,
  SEARCH_RAILS_SCROLL_UP: `transform ${DURATION.SEARCH_RAILS_SCROLL}ms ${DELAY.SEARCH_RAILS_SCROLL_UP}ms`,
  SPINNER_PATH: `${DURATION.SPINNER_PATH}ms`,
  SWITCHER_BALL: `transform ${DURATION.SWITCHER_BALL_TRANSFORM}ms, background ${DURATION.SWITCHER_BALL_BACKGROUND}ms`,
} as const;
